export default "__VITE_ASSET__fa30a323__"